import { FilterType } from "@shared/types";
import { FILTER_TYPES_DATA } from "@shared/features/filters/constants";

export const getParsedQueryFilters = (
  filterTypes: FilterType[],
  query: URLSearchParams
) => {
  return filterTypes?.reduce(
    (acc: { [key in FilterType]?: any }, filterType) => {
      const queryKey = FILTER_TYPES_DATA[filterType].queryKey;
      let queryValue: any = query.get(queryKey);
      try {
        queryValue = queryValue ? JSON.parse(queryValue) : undefined;
      } catch {
        queryValue = undefined;
      }
      if (queryValue !== undefined) {
        acc[filterType] = queryValue;
      }
      return acc;
    },
    {}
  );
};
